// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"17e8e18a","422":"462640cd"}[chunkId] + ".chunk.js";
};